import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import {ImageBuffer, Loader} from '../';
import { SearchRounded } from '../../utils/constants';

import './mainSearch.css'

const MainSearch = ({searchCat}: any) => {
    // const {isLoading, getPostsByStoreId} = useSelector((state) => state?.postList)
    const dispatch                       = useDispatch();
    const navigate                       = useNavigate();
    const location                       = useLocation();
    const searchParams                   = new URLSearchParams(location.search);
    //this will read the url and see if a page is available
    const searchQuery                    = searchParams.get('searchQuery')
    const page                           = searchParams.get("page") || 1
    const [search, setSearch]            = useState<string>('');
    const [results, setResults]          = useState(false);
    const keys                           = ["title", "description"]

    const searchStorePost = () => {
        if(search.trim()){
            navigate(`/search/search?searchQuery=${search || ''}`)
        }else{
            navigate(`/search/search`)
        }
    }

    const handleSearchChange = (e: any) =>{
        setSearch(e.target.value)
    }

    const handleKeyPress = (e: any) => {
        if(e.keyCode === 13){ //this simply means the enter key
            searchStorePost();
        }
    }

    // useEffect(() => {
    //     dispatch(actionFetchPostsByStoreId(id, page))
    // }, [id, searchQuery, page, dispatch])

    useEffect(() => {
        if(search === ''){
            setResults(false)
        }else{
            setResults(true)
        }
    }, [search])

  return (
    <>
        <div className='main-search-header-container'>
            <form className='main-search-header-form-wrapper'>
                <div className='main-search-header-form-input-wrapper'>
                    <input value={search} type="text" onChange={handleSearchChange} placeholder={searchCat ? searchCat : 'Search'} onKeyDown={handleKeyPress} autoComplete='off' />
                    <button onClick={() => searchStorePost()} className='main-search-header-search-btn'><SearchRounded /></button>
                </div>
                <div className={results ? 'main-search-header-form-result active' : 'main-search-header-form-result'}>
                    <div className='main-search-header-result-wrapper'>
                        {/* {isLoading ? <Loader /> : getPostsByStoreId.filter((result) => {
                            return keys.some((key) => result[key].toLowerCase().includes(search))
                        }).splice(0, 5)
                        .map((result, index) => (
                        <Link key={index} to={`/posts/post/${result._id}`} className='main-search-header-dropdown-menu-details'>
                            <div className='main-search-header-dropdown-menu-img'><ImageBuffer src={result.selectedFile} alt='pic' index={index} /></div>
                            <span>{result.title}</span>
                        </Link>
                        ))} */}
                        <div className='main-search-header-dropdown-menu-all-results' onClick={searchStorePost}>See all Results</div>
                    </div>
                </div>
            </form>
        </div>
    </>
  )
}

export default MainSearch